<!-- 試用版申込フォーム STEP4：申込完了メッセージを表示する完了画面 -->
<template>
  <PageHeader />

  <div class="content-container">
    <StepNavigator :current="4" />

    <div class="complete-box">
      <h2 class="complete-title">お申し込みが完了いたしました。</h2>

      <p class="complete-text">
        送付先メールアドレスへお送りいたしました自動送信メールの内容をご確認ください。<br />
        メールに記載されているURLから管理ツールへアクセスいただけます。
      </p>

      <p class="complete-text">
        試用期間はお申し込み日から<strong>3ヶ月間</strong>です。
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import StepNavigator from "../components/StepNavigator.vue";
import PageHeader from "../components/layout/PageHeader.vue";
import { useExperienceFormStore } from "../store/useExperienceFormStore";
import { clearStepFlags } from "../router/index";

const store = useExperienceFormStore();

// Step4に到着したらフォームリセットとフラグクリアを実行
onMounted(() => {
  store.resetForm();
  clearStepFlags();
});
</script>

<style scoped>
.complete-box {
  background: linear-gradient(180deg, #fff9e6 0%, #fffdf5 100%);
  border: 1px solid #f0e6c8;
  padding: 32px;
  margin: 32px auto;
  max-width: 800px;
}

.complete-title {
  font-size: 1.25rem;
  margin-bottom: 16px;
}

.complete-text {
  font-size: 0.95rem;
  line-height: 1.8;
  margin-bottom: 12px;
}
</style>
